import { Button } from "components"
import mainBg from "./siteplanbg.webp"
import UploadBg from "./uploadImg.webp"

export const EditSitePlan = () => {
 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <h1 className="Jakarta-font font-bold text-xl py-6">Lageplan bearbeiten</h1>

   <ul className="flex w-full Jakarta-font">
    <li className="text-lg p-4 bg-white cursor-pointer rounded-t-md">
     <a href="/">STm.5</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">STm.6</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">Testanlage 01</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">Testanlage Copy 01</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">USM-Test</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/"> XXX XXX</a>
    </li>
   </ul>
   <div
    className="relative"
    style={{
     backgroundImage: `url(${mainBg})`,
     backgroundPosition: "center",
     backgroundSize: "cover",
     width: "100%",
     minHeight: "845px",
    }}
   >
    <div
     className="bg-white justify-center items-center max-w-2xl p-7 absolute inset-0
         left-5 top-5 rounded min-h-fit"
    >
     <p className="text-lg text-dark-black font-semibold">Bearbeiten</p>
     <div className="flex justify-between items-center py-3.5">
      <p className="text-base font-medium text-dark-black">Bearbeiten</p>
      <input
       type="text"
       name=""
       placeholder=" 60"
       className="text-base font-medium bg-light-gray2 py-4 px-5 rounded-lg w-3/4 outline-none placeholder:text-dark-black"
      />
     </div>
     <div className="flex justify-between items-center py-3.5">
      <p className="text-base font-medium text-dark-black">Signal Group:</p>
      <input
       type="text"
       name=""
       placeholder=" 60"
       className="text-base font-medium bg-light-gray2 py-4 px-5 rounded-lg w-3/4 outline-none placeholder:text-dark-black"
      />
     </div>
     <div className="flex justify-between items-center py-3.5">
      <p className="text-base font-medium text-dark-black">Signal Generator:</p>
      <input
       type="text"
       name=""
       placeholder=" 60"
       className="text-base font-medium bg-light-gray2 py-4 px-5 rounded-lg w-3/4 outline-none placeholder:text-dark-black"
      />
     </div>
     <div className="flex justify-between items-center py-3.5">
      <p className="text-base font-medium text-dark-black">Signal Generator:</p>
      <Button size={"xl"} color={"yellow"} className="w-9/12">
       Extinguish
      </Button>
     </div>
     <div className="flex flex-col justify-between py-3.5">
      <p className="text-base font-medium text-dark-black">Map:</p>
      <div className="relative cursor-pointer mb-4 w-full  flex justify-center px-6 py-4 border-2 border-[#DCDCDC] border-dashed rounded-md h-32">
       <input
        multiple={false}
        type="file"
        className="absolute inset-0 cursor-pointer opacity-0"
        accept=".pdf,.doc,.docx,.txt,"
       />
       <div className="flex flex-col justify-center items-center space-y-3.5 text-center">
        <img src={UploadBg} alt={UploadBg} />
        <p className="font-xs font-medium text-dark-black">Click or drag file to upload</p>
       </div>
      </div>
     </div>
     <Button size={"xl"} color={"yellow"} className="pt-4">
      Save on Computer
     </Button>
    </div>
   </div>
  </div>
 )
}
